export const TRACK_ACTIONS = {
    GO_TO_MENU: "MENU",
    QUICK_ACTION: "QUICK_ACTION",
    QUICK_ACTION_CARD: "quickAction",
    BILL_PAY_ACTION: "CONFIRMATION_TASK",
    GENERATE_BILL_CONFIRMATION_TASK: "GENERATE_BILL_CONFIRMATION_TASK",
    PAY_WAITER_CONFIRMATION_TASK: "quickActionHalfCard",
    RELOAD_BILL: "RELOAD",
    DOWNLOAD_BILL: "DOWNLOAD",
    RETRY_BILL_BY_USER: "RETRY",
};

export const TRACK_ICONS = {
    SUCCESS_ICON: "portal/static-assets/images/digital-menu/all-theme-assets/tick.png",
};

// Time offset for popup frequency capping (3 hours in ms)
export const POPUP_WIDGET_FREQUENCY_TIMEOFFSET_MS = 3 * 60 * 60 * 1000;
